import { FC } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { formatPhoneNumber } from '../../../helpers/funcs';

type Props = {
  value: string | undefined;
  onChange?: (newValue: any) => void;
  onBlur?: (event: any) => void;
  className?: string;
  classNamePrefix?: string;
  classNameDisabled?: string;
  disabled?: boolean;
  autoComplete?: string;
};

const Phone: FC<Props> = (props) => {
  return (
    <>
      {!props.disabled ? (
        <PhoneInput
          placeholder="Phone number"
          defaultCountry="US"
          countryCallingCodeEditable={false}
          withCountryCallingCode={false}
          initialValueFormat="national"
          displayInitialValueAsLocalNumber={true}
          international={false}
          value={props.value}
          onChange={(val) => {
            if (props.onChange) props.onChange(val);
          }}
          onBlur={(event) => {
            return props.onBlur && props.onBlur(event);
          }}
          className={props.className}
          autoComplete={props.autoComplete}
        />
      ) : (
        <div
          className={
            props.classNameDisabled ? props.classNameDisabled : 'pt-3 pb-3 fw-bold fs-4 mb-3 mb-lg-0 cursor-default'
          }
        >
          {props.value && (
            <a href={'tel:' + props.value} target="_blank">
              {formatPhoneNumber(props.value)}
            </a>
          )}
        </div>
      )}
    </>
  );
};

export { Phone };
